import script from "./LinkingBusiness.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkingBusiness.vue?vue&type=script&lang=ts&setup=true"

import "./LinkingBusiness.vue?vue&type=style&index=0&id=69c3af31&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c3af31"]])

export default __exports__